<template>
  <v-container class="px-2">
    <Navbar />
      <v-card>
        <v-alert v-model="alertAxios" border="left" close-text="Close Alert" dismissible dense outlined type="error">
            Ha ocurrido un error!
        </v-alert>
        <v-toolbar dark color="#00b2bb">
          <v-col>
            <h2 class="ml-2 headline font-weight-thin">{{ documento.name }}</h2>
          </v-col>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-btn class="mr-2" disabled icon dark v-on="on">
                <v-icon dark @click="downloadFile">mdi-download</v-icon>
              </v-btn>
            </template>
            <span>Descargar</span>
          </v-tooltip>
        </v-toolbar>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col xs="6" md="4" v-if="documento.numeroOt">
                  <h4 class="font-weight-regular black--text">Nº OT</h4>
                  <v-text-field
                    solo
                    disabled
                    v-model= documento.numeroOt
                  ></v-text-field>
                </v-col>
                <v-spacer></v-spacer>
                <v-col xs="6" md="4"
                offset-md="4">
                  <h4 class="font-weight-regular black--text">Fecha</h4>
                  <v-text-field
                    :value = "displayValue(documento.fecha)"
                    solo
                    disabled
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="6" md="6">
                  <h4 class="font-weight-regular black--text">Trámite</h4>
              <v-text-field
                  solo
                  disabled
                  v-model= documento.nombreTramite
                ></v-text-field>
                </v-col>
              </v-row>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left  black--text">Nombre:</th>
                      <th class="text-left  black--text">Correo:</th>
                      <th class="text-left  black--text">RUT</th>
                      <th class="text-left  black--text">Estado</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="firmo in documento.firmantes" :key="firmo.nombre">
                      <td>{{ firmo.nombre }}</td>
                      <td>{{ firmo.correo }}</td>
                      <td>{{ firmo.rut }}</td>
                      <td v-if="firmo.firmado">Firmado</td>
                      <td v-else>Por Firmar</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-row>
                <v-spacer></v-spacer>
                <v-col cols="12" xs="12" md="4"
                offset-md="4" lg="4" sm="6">
                  <h4 class="font-weight-regular black--text">Costo Servicio Firma Electronica TOC</h4>
                  <v-text-field
                    label="TOC"
                    solo
                    width="50px"
                    prepend-inner-icon="mdi-currency-usd"
                    disabled
                    v-model= documento.precioToc
                    ></v-text-field>
                  <h4 class="font-weight-regular black--text">Costo Notaria</h4>
                  <v-text-field
                    label="Notaria"
                    solo
                    width="50px"
                    prepend-inner-icon="mdi-currency-usd"
                    disabled
                    v-model= documento.precioTramite
                    ></v-text-field>
                  <h4 class="font-weight-regular black--text">Costo Total</h4>
                  <v-text-field
                    label="Total"
                    solo
                    width="50px"
                    prepend-inner-icon="mdi-currency-usd"
                    disabled
                    v-model= documento.precioTotal
                    ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <template>
                  <v-row class="ma-5 justify-center" cols="12" xs="12" md="4" lg="4">
                    <v-btn color="normal" :to="'/mydocument/documentlist'">Volver</v-btn>
                  </v-row>
                </template>
                <!-- <template>
                  <v-row>
                      <v-dialog v-model="dialog" persistent max-width="290">
                        <template v-slot:activator="{ on }">
                          <v-row class="ma-5 justify-left" xs="6" md="4" lg="4">
                            <template >
                              <v-btn color="normal" :to="'/mydocument/documentlist'" style="margin-top: 40px;"
                              >Cancelar</v-btn>
                              <v-spacer></v-spacer>
                              <v-btn v-if="status" color="#00b2bb" dark @click="handleSubmit" v-on="on" style="margin-top: 40px;"
                              >Pagar</v-btn>
                              <v-btn v-else color="#00b2bb" dark @click="handleSubmit" v-on="on" style="margin-top: 40px;"
                              disabled>Pagar</v-btn>
                            </template>
                          </v-row>
                        </template>
                        <v-card>
                          <v-card-title class="headline">Trámite Pago</v-card-title>
                          <v-card-text>Se ha pagao el Trámite con exito!</v-card-text>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="#00b2bb" :to="`/Boleta/${documento.id}`" text @click="dialog = false">Aceptar</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                  </v-row>
                </template> -->
              </v-row>
            </v-container>
          </v-card-text>
      </v-card>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
  </v-container>
</template>

<script>
// @ is an alias to /src
import Navbar from '@/components/Navbar.vue'
import api from '@/plugins/api'
import moment from '@/plugins/moment'
import axios from 'axios'

export default {
  name: 'EndDocument',
  components: {
    Navbar
  },
  data () {
    return {
      titulo: 'Tramite',
      url: '',
      dialog: false,
      overlay: false,
      alertAxios: false,
      status: this.status,
      id: this.$route.params.id,
      firmantes: [],
      documento: []
    }
  },
  mounted () {
    this.getTodos(this.$route.params.id)
    this.overlay = !this.overlay
    /* this.validateSignature() */
  },
  watch: {
    overlay (val) {
      val && setTimeout(() => {
        this.overlay = false
      }, 5000)
    }
  },
  methods: {
    validateSignature () {
      this.status = true
      Object.keys(this.firmantes).forEach(key => {
        if (this.firmantes[key].status === 'Pendiente') {
          this.status = false
          console.log('Estatus ' + this.status)
        }
      })
    },
    handleSubmit () {
      if (this.FormDataHasError) {
        /* console.log('Hay un error en el formulario') */
      }
      /* Object.keys(this.formData).forEach(key => {
        const label = this.formData[key].label
        const value = this.formData[key].value
        this.datos.push(label, value)
      }) */
      /* this.datos.push('fecha:', this.fecha) */
      /* localStorage.setItem('info_pago', JSON.stringify({ formulario: this.datos })) */
    },
    async getTodos (id) {
      try {
        const response = await api.get(`mis-tramites/${id}`)
        this.documento = response.data
        console.log(this.documento)
        /* this.url = this.documento.url */
      } catch (error) {
        this.alertAxios = true
        console.log('Get error ' + error)
      }
    },
    forceFileDownload (response) {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      console.log('aca ' + link.href)
      link.setAttribute('download', 'file.png') // or any other extension
      document.body.appendChild(link)
      link.click()
    },
    downloadFile () {
      axios({
        method: 'get',
        url: this.url,
        responseType: 'arraybuffer'
      })
        .then(response => {
          this.forceFileDownload(response)
        })
        .catch(() => console.log('Error al descargar archivo'))
    },
    displayValue (value) {
      console.log('Fecha ' + value)
      return value ? moment(value).format('DD-MM-YYYY') : ''
    }
  }
}
</script>
